import type { ChatViewState } from './chat-view-state.helper'

export interface InputDisabledConfig {
  isDisabled: boolean
  placeholder: string | undefined
}

export const getChatInputDisabledConfig = (state: ChatViewState): InputDisabledConfig => {
  const isDisabled = state.isBalanceDepleted && state.inputMode === 'message'
  return {
    isDisabled,
    placeholder: isDisabled ? 'Top up your balance to send messages' : undefined,
  }
}
